module.exports = __webpack_public_path__ + "img/mainmenbuttonRL.70a89b66.png";